// 用于设置rem 进行适配
(function(doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function() {
      var clientWidth = Math.min(docEl.clientWidth, 640);
      if (!clientWidth) return;
      docEl.style.fontSize = 20 * (clientWidth / 375) + 'px';
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);

  var isiPhone= /iPhone/i.test(navigator.userAgent);//手机机型判断
  if(isiPhone) {//ios 禁止页面缩放
    // 阻止双击放大
    var lastTouchEnd = 0;
    doc.addEventListener('touchstart', function(event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    });
    doc.addEventListener('touchend', function(event) {
      var now = (new Date()).getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);
    // 阻止双指放大
    doc.addEventListener('gesturestart', function(event) {
      event.preventDefault();
    });
  } else {//Android 输入框获取焦点防止键盘遮挡
    doc.addEventListener('click', function(event) {
      if(event.target.getAttribute("contenteditable")=="true" || event.target.getAttribute("type")=="search" || event.target.getAttribute("type")=="number" || event.target.getAttribute("type")=="text") {
        var scrollTop = doc.documentElement.clientHeight - 340;//如果输入框距离底部小于300px，获取焦点时上移content防止键盘遮挡
        if(event.clientY > scrollTop) {//输入框距底部小于 340px
          // document.querySelector(".my-content").scrollTop += event.clientY + event.target.offsetHeight - scrollTop;
          // var scrollHeight = event.clientY + event.target.offsetHeight - scrollTop
          // (function fn() {
          //     var stepL = scrollHeight/5
          //     if(stepL > 5) {
          //         scrollHeight -= stepL
          //         document.querySelector(".content").scrollTop += stepL
          //         setTimeout(fn, Math.max(300/stepL, 20))
          //     } else {
          //         document.querySelector(".content").scrollTop += stepL
          //     }
          // })()
        }
      }
    });
  }
})(document, window);
